<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
				<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de seguimiento">
					<div class="container-fluid">
						<div class="row" id="slide-1">
							<div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
								<div class="p-3 pl-lg-5">
									<h2 class="mt-5">Actividad de seguimiento</h2>
									<h3>Adquisición del lenguaje</h3>
									<h5>Tipo de actividad: cuestionario (selección múltiple)</h5>
									<h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
									<p>Reconocer las nociones básicas de adquisición del lenguaje.</p>
									<h4 class="mt-3">¿Qué hacer?</h4>
                                    <p>Lea con atención los enunciados y seleccione la respuesta que considere correcta.</p>
                                </div>
							</div>
							<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-AS justify-content-center align-items-center"> 
								<div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
									<div class="mb-xl-3 mb-lg-3 row ml-xl-3 bg-white ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100 p-4">
                                        <div class="col-12 mb-4">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>1. La psicolingüística, como disciplina entre la psicología y la lingüística, tiene un objeto de estudio definido que es:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                     <button v-b-popover.click.blur.html='respuesta1Pos' class="Radiobutton checkAE mr-2 checkAE_1" id="checkAE_1_A" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>a) La explicación de los procesos de comprensión, producción, desarrollo y adquisición del lenguaje.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_1" id="checkAE_1_B" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>b) La explicación de los procesos de comprensión, producción, reflexión y adquisición del lenguaje.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>2. Una de las principales críticas que le hace el modelo chomskiano al conductismo radica en establecer que los procesos de estímulo-respuesta no son una explicación científica de la adquisición del lenguaje porque generan un proceso del tipo:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_A" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>a) Causal: no hay una relación clara entre las causas conductuales que llevan al lenguaje y las consecuencias en su desarrollo.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta2Pos' class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_B" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>b) Determinista: hay un determinismo operante que considera que el lenguaje se desarrolla por el confinamiento mecánico. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>3. Desde la época clásica, los filósofos griegos reconocieron que existían dos patrones que eran generales para todas las lenguas. Estos son:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_A" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>a) Los niveles de la lengua y las gramáticas.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html='respuesta3Pos' class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_B" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>b) Los universales y los específicos lingüísticos. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>4. La década de 1980 estuvo marcada por el auge de la ciencia cognitiva, la cual tuvo importancia en diferentes campos lingüísticos como la psicolingüística y la textolingüística, lo que llevó a un cambio en el abordaje de los textos llamado:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html='respuesta4Pos' class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_A" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>a) Giro cognitivo, por el cambio en la forma de entender el texto, la cual pasó de la gramática a la visión contextual y comprensiva. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_B" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>b) Generativismo, por transformar las bases de la lingüística en el siglo XX.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>5. Cuando se investiga desde los aspectos lingüísticos, los investigadores asumen que las evidencias del lenguaje deben responder al criterio de:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                         <button v-b-popover.click.blur.html="'<b>¡Incorrecto!</b>'" class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_A" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>a) Los aspectos metalingüísticos que los hablantes evidencien en el uso del lenguaje.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html='respuesta5Pos' class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_B" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>b) La intuición lingüística que tengan los hablantes en el uso de la lengua. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                            <button class="btn BtnPrincipal d-flex mx-auto mt-4 mb-4" @click="recargarPagina">Intentar nuevamente</button>
                                        </div>

									</div>
                                    <p class="RefimgActiv">Foto por Aaron Burden en <a href="https://www.pexels.com/es-es/foto/blanco-y-negro-persona-manos-sujetando-4061218/" target='_blank' class="text-white">Unsplash</a></p>
 
								</div>

							</div>
						</div>
					</div>
				</div>
        </div>
    </div>
</template>

<script>
import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'ActividadSeguimiento',
    data(){
      return{
        respuesta1Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Como se ha señalado en la unidad, la psicolingüística tiene por objeto de estudio tres procesos fundamentales: en primer lugar, busca explicar la comprensión que tienen los seres humanos del lenguaje hablado y escrito; en segundo lugar, los aspectos que comprenden la producción del habla; y finamente, todo lo relacionado con las diversas etapas de adquisición del código.</p>',
        respuesta2Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Los aportes chomskianos al desarrollo evidenciaron que el conductismo era una teoría mecanicista que intentaba explicar los procesos del desarrollo desde un determinismo condicionante que tenía como principio la relación de estímulo y respuesta.</p>',
        respuesta3Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Desde la época clásica, en los postulados de Aristóteles se comprendía que existía una doble dimensión en las lenguas: un universal lingüístico y los específicos lingüísticos. El primero de ellos obedece a los rasgos que pueden ser observables y se mantienen en todas las lenguas (como el hecho de compartir una estructura organizada por los niveles de la lengua), mientras que el segundo corresponde a los usos particulares que las culturas hacen de las lenguas.</p>',
        respuesta4Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">El giro cognitivo supuso un cambio en la concepción de las tipologías textuales desde la perspectiva de la psicología, lo que dio paso a considerar las formas en que los individuos comprenden y producen los textos, así como el contexto social.</p>',
        respuesta5Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">El eje de este tipo de investigación es indagar por esos rasgos intuitivos que se presentan, así como por la expresión de la lengua materna y los fenómenos introspectivos y subjetivos de los individuos en el uso.</p>',
        popovers:[false,false,false,false,false]
      }
    },
    methods: {
    activar: function(event,numPregunta){
   
      let elementosGrupo=document.querySelectorAll(".checkAE_"+numPregunta);
     
      elementosGrupo.forEach(element => {
          element.classList.remove("active","i-check");
      });

     event.target.classList.add("active","i-check");

    //    elementosGrupo.forEach(element => {
    //     element.style.pointerEvents='none';
    //    });

    },

    recargarPagina: function(){
        location.reload();
    }
  },
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title // Cambiar el título de la página
    }
}
</script>